import { render, staticRenderFns } from "./common-title.vue?vue&type=template&id=d877337c&scoped=true&"
import script from "./common-title.vue?vue&type=script&lang=js&"
export * from "./common-title.vue?vue&type=script&lang=js&"
import style0 from "./common-title.vue?vue&type=style&index=0&id=d877337c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d877337c",
  null
  
)

export default component.exports